/* eslint-disable */

import {VueEditor} from "vue2-editor";
import {mapGetters} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'createNewCourse',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      name: '',
      category: '',
      description: '',
      submitted: false,
      errorMessage: '',
      step2: false,
      coursesCategory: {},
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
    }
  },
  computed: {
    ...mapGetters([
      'getcourseCategoryState'
    ]),
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    }
  },
  mounted() {},
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            category: this.category,
            description: this.description
          }
          this.$store.dispatch('create_course', data).then((res) => {
            if (res.status == '201') {
              this.$router.push('/course/' + res.data.data.id + "/tab/")
              toast.success(res.data.msg);
            }
          }).catch((err) => {})
          return
        }
      });
    }
  },
  beforeMount() {
    this.getCourseList;
  },
  watch: {
    getCourseList() {
      return this.$store.getters.getcourseCategoryState.data
    }
  }
}